import React, { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

const Snackbar = ({ message, open, type, onClose }) => {
    useEffect(() => {
        let timeoutId;
        if (open) {
            timeoutId = setTimeout(() => {
                onClose();
            }, 2000);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [open, onClose]);

    // Base classes
    const snackbarClasses = "fixed top-4 right-4 text-white px-4 py-3 rounded-md shadow-md flex items-center justify-between transition-all duration-300 max-w-sm";

    // Visibility classes
    const visibilityClasses = open ? "translate-x-0 opacity-100" : "translate-x-full opacity-0";

    // Type-based styles
    let typeClasses = "bg-blue-500"; // Default (info)
    let Icon = Info;

    if (type === "success") {
        typeClasses = "bg-green-500";
        Icon = CheckCircle;
    } else if (type === "error" || type === "serror") {
        typeClasses = "bg-red-500";
        Icon = AlertCircle;
    } else if (type === "loading") {
        typeClasses = "bg-blue-500";
        Icon = Info;
    }

    return (
        <div className={`${snackbarClasses} ${visibilityClasses} ${typeClasses}`}>
            <div className="flex items-center">
                <Icon size={18} className="mr-2" />
                <span>{message}</span>
            </div>
            <button
                className="ml-4 text-white hover:text-gray-200 transition-colors focus:outline-none"
                onClick={onClose}
                aria-label="Close"
            >
                <X size={18} />
            </button>
        </div>
    );
};

export default Snackbar;